var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnLargeWatchlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.994 41.6v24.835a6.6 6.6 0 0 1-6.609 6.608H16.141a6.6 6.6 0 0 1-6.609-6.608V20.176a6.6 6.6 0 0 1 6.609-6.608h11.014M27.155 44.407h17.622M27.155 35.596h8M27.155 53.218H40.37M27.155 62.03H46.98",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51.2 3.2 4.944 10.007L67.2 14.813l-8 7.79L61.089 33.6l-9.89-5.193-9.888 5.193L43.2 22.601l-8-7.789 11.056-1.604L51.2 3.2z",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.546 37.799a2.203 2.203 0 1 0 0-4.406 2.203 2.203 0 0 0 0 4.406zM20.546 46.61a2.203 2.203 0 1 0 0-4.406 2.203 2.203 0 0 0 0 4.406zM20.546 55.421a2.203 2.203 0 1 0 0-4.405 2.203 2.203 0 0 0 0 4.405zM20.546 64.232a2.203 2.203 0 1 0 0-4.405 2.203 2.203 0 0 0 0 4.405z",
    fill: "#003A70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLargeWatchlist);
export default __webpack_public_path__ + "static/media/icn_large_watchlist.wtn-site.svg";
export { ForwardRef as ReactComponent };